var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "31.5 285.5 13.5 13.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#0071e3",
    cx: 38.38,
    cy: 292.18,
    r: 6.01
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "41.16 292.68 38.66 292.68 38.66 295.18 37.66 295.18 37.66 292.68 35.16 292.68 35.16 291.68 37.66 291.68 37.66 289.18 38.66 289.18 38.66 291.68 41.16 291.68 41.16 292.68"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.8dfecff57f140d385d29dda24179ca64.svg";
export { ForwardRef as ReactComponent };